<template>
  <Teleport to="body">
    <div class="sub-modal-backdrop" @click="$emit('cancel')">
      <div class="sub-modal card" @click.stop>
        <div class="card-body">
          <p class="sub-modal__body mb-4">{{ bodyText }}</p>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-outline-secondary flex-fill" @click="$emit('cancel')">
              {{ $t('shared.cancel_2') }}
            </button>
            <button type="button" class="btn btn-primary flex-fill" @click="$emit('go')">
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ bodyText: string; confirmLabel?: string }>(), { confirmLabel: "Go" });
defineEmits<{ (e: "cancel"): void; (e: "go"): void }>();
</script>

<style scoped lang="scss">
.sub-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1.5rem;
}

.sub-modal {
  max-width: 420px;
  width: 100%;
  border-radius: 16px;

  &__body {
    font-size: 1.05rem;
    font-weight: 600;
  }
}
</style>
